<div>
  <div class="px-4 pt-4">
    <h2 class="text-lg font-bold text-site text-center">🎟️ Code Promo</h2>

  </div>

  <mat-dialog-content>
    <div class="flex flex-col gap-3 w-full">
      @if (!data?.promoCode) {
        <div class="flex items-center gap-2 w-full">
          <input
            [(ngModel)]="promoCode"
            (keyup.enter)="search()"
            placeholder="Entrez votre code..."
            class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-primary"/>
            <button
              [matButton]="themeConfig.appearance.button.action"
              (click)="search()"
              [disabled]="isLoading || !promoCode.trim()"
          class="">
              {{ isLoading ? '...' : 'Chercher' }}
            </button>
          </div>
        }
        @if (errorMessage === 'SAME_CODE') {
          <div
            class="bg-orange-50 border border-orange-200 rounded-xl p-3 text-center">
            <p class="text-orange-600 font-bold text-sm">🎟️ Ce code est déjà dans votre panier !</p>
            <p class="text-gray-500 text-xs mt-1">Vous profitez déjà de cette promotion.</p>
          </div>
        }

        @if (errorMessage === 'OTHER_CODE') {
          <div
            class="bg-red-50 border border-red-200 rounded-xl p-3 text-center">
            <p class="text-red-600 font-bold text-sm">⚠️ Un autre code promo est déjà actif</p>
            <p class="text-gray-500 text-xs mt-1">Retirez-le depuis votre panier pour utiliser un autre code.</p>
          </div>
        }

        @if (errorMessage && errorMessage !== 'SAME_CODE' && errorMessage !== 'OTHER_CODE') {
          <p
            class="text-red-500 text-sm text-center">
            ⚠️ {{ errorMessage }}
          </p>
        }
        <!--      <div *ngIf="successPromo"-->
        <!--           class="bg-green-50 border border-green-200 rounded-xl p-4 flex flex-col gap-3">-->


        <!--        <div>-->
        <!--          <span class="font-bold text-green-700 text-base">{{ successPromo.title }}</span>-->

      <!--        </div>-->


      <!--        <div class="flex flex-wrap gap-2 text-xs">-->

      <!--       <span *ngIf="successPromo.payload?.reduction"-->
      <!--             class="px-2 py-1 bg-blue-100 text-blue-700 rounded-full font-semibold">-->

      <!--  <ng-container [ngSwitch]="successPromo.payload.reduction.type">-->

      <!--    <span *ngSwitchCase="'PERCENTAGE'">-->
      <!--      -{{ successPromo.payload.reduction.value * 100 }}%-->
    <!--    </span>-->

    <!--    <span *ngSwitchCase="'FIXED_AMOUNT'">-->
    <!--      -{{ successPromo.payload.reduction.value }}€-->
  <!--    </span>-->

  <!--    <span *ngSwitchCase="'SET_PRICE'">-->
  <!--     Chaque produit de la promo est à {{ successPromo.payload.reduction.value }}€-->
<!--    </span>-->

<!--    <span *ngSwitchDefault>-->
<!--      Réduction appliquée-->
<!--    </span>-->

<!--  </ng-container>-->

<!--</span>-->
<!--        </div>-->

<!--        <button-->
<!--          (click)="apply()"-->
<!--          class="w-full py-2.5 bg-[#1A1A1A] hover-bg-black-5 text-[#FFFFFF] rounded-lg font-bold text-sm-->
<!--           transition-all">-->
<!--          🎁 En profite-->

<!--        </button>-->
<!--      </div>-->
    </div>

  </mat-dialog-content>

  <div class="px-4 pb-4">
    <button (click)="cancel()"
            [matButton]="themeConfig.appearance.button.cancel"

            class="w-full py-2">
    Annuler
  </button>
</div>

</div>
